import { Action } from 'redux';
import { BookmarkInfo, BookmarkModifyInfo, BookmarkCreateInfo } from '..';
import * as uuidv4 from 'uuid/v4';

export enum ActionNames {
  APPEND_BOOKMARK = 'APPEND_BOOKMARK',
  DELETE_BOOKMARK = 'DELETE_BOOKMARK',
  MODIFY_BOOKMARK = 'MODIFY_BOOKMARK',
}

export interface AppendBookmarkAction extends Action {
  type: typeof ActionNames.APPEND_BOOKMARK;
  info: BookmarkInfo;
}

export interface DeleteBookmarkAction extends Action {
  type: typeof ActionNames.DELETE_BOOKMARK;
  id: string;
}

export interface ModifyBookmarkAction extends Action {
  type: typeof ActionNames.MODIFY_BOOKMARK;
  info:  Partial<BookmarkInfo>;
}

export type BookmarkAction = AppendBookmarkAction | ModifyBookmarkAction | DeleteBookmarkAction;

export function appendBookmark(
  { reference, title, createdBy, isImported }: BookmarkCreateInfo,
) : AppendBookmarkAction {
  const date = new Date();
  return {
    type: ActionNames.APPEND_BOOKMARK,
    info: {
      reference, title, createdBy, isImported,
      id: uuidv4(),
      createdAt: date.toISOString(),
      updatedAt: date.toISOString(),
    },
  };
}

export function deleteBookmark(id: string) : DeleteBookmarkAction {
  return { id, type: ActionNames.DELETE_BOOKMARK };
}

export function modifyBookmark(id: string, info: BookmarkModifyInfo) : ModifyBookmarkAction {
  const date = new Date();
  return {
    info: { ...info, id, updatedAt: date.toISOString() },
    type: ActionNames.MODIFY_BOOKMARK,
  };
}

export function isBookmarkAction(action: Action): action is BookmarkAction {
  switch (action.type) {
    case ActionNames.APPEND_BOOKMARK:
    case ActionNames.DELETE_BOOKMARK:
    case ActionNames.MODIFY_BOOKMARK:
      return true;
    default:
      return false;
  }
}
